module.exports = __webpack_public_path__ + "static/media/aeTile2.9fa6495f.png";